import "../Styles/Footer.css";

function Footer() {
    return (
        <section className="contact-us" id="contact">
            <div className="footer">

                <div>
                    <h4></h4>
                    <p >
                        İletişim Bilgileri
                        <br/>
                        RSG Bilgi Teknolojileri Sağlık ve İnovasyon Hizmetleri Ltd. Şti.
                        <br/>
                        Başıbüyük Mah.
                        Süreyyapaşa Başıbüyük Yolu Sokak
                        <br/>
                        No.: 4/1 İç Kapı No.: 1
                        Maltepe - İstanbul
                        <br/>
                        E-mail: info@rsg
                    </p>
                </div>
                <p>
                    ©2025 RSG Tüm hakları saklıdır.
                    <br/>
                    Tasarım: <a href="https://www.linkedin.com/in/ayse-gulsum-eren/" target="_blank"
                                rel="noopener noreferrer">Ayşe Gülsüm Eren</a>
                </p>
            </div>
        </section>
    );
}

export default Footer;
